import { obfuscated } from "../../common/common.css.ts";
import type { RichText } from "../../engine/common.ts";
import { useCheckAccessResult } from "../CheckAccess/context.ts";

export function RichContent(props: { children: RichText }) {
  const [result] = useCheckAccessResult();
  const dummyText =
    "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

  if (
    result.isSuccess &&
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    result.value.unlocks.some((u) => u.feature === "SPACE_GITS_CORE_RULES")
  ) {
    return <span>{props.children}</span>;
  }

  return (
    <span className={obfuscated()}>
      {dummyText.slice(0, props.children.length)}
    </span>
  );
}
